import EventComponent from '@components/event';
import * as React from 'react';

export interface IEventpageProps {}

export default function Eventpage(props: IEventpageProps) {
  return <EventComponent />;
}
